<template>
  <div
    class="space-y-4 p-4 h-full p-4 box-border overflow-y-auto overflow-x-hidden"
  >
    <viewTitle
      :title="
        `业务管理 / 基础数据管理 / 自助取样点管理/ ${
          this.recordId == 0 ? '新建' : '修改'
        }装卸点`
      "
      :showReturn="true"
    />
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="所属基地" required>
        {{ baseInfo.com_name }}
      </el-form-item>
      <el-form-item label="装卸点类型" prop="loading_unloading_type">
        <el-radio-group
          :disabled="this.recordId != 0"
          v-model="form.loading_unloading_type"
          @change="onLoadingUnloadingTypeChange"
        >
          <el-radio :label="11">取样+装卸</el-radio>
          <el-radio :label="3">仅装卸</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="装卸点名称" prop="name">
        <el-input
          class="w-96"
          v-model="form.name"
          placeholder="请输入装卸点名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆业务类型" prop="car_business_list">
        <template v-if="form.car_business_list.length > 0">
          <c-table
            size="mini"
            class="w-1/2"
            :isIndex="false"
            :data="form.car_business_list"
            :columns="columns"
            :showPagination="false"
          >
            <template slot="car_business_name" slot-scope="{ row }">
              <div v-for="item in row.car_business" :key="item.id">
                {{ item.name }}
              </div>
            </template>
            <template slot="calling_priority" slot-scope="{ row }">
              <el-select
                v-model="row.calling_priority"
                size="mini"
                class="w-24"
                placeholder="优先级"
              >
                <el-option label="不优先" :value="0"></el-option>
                <el-option label="1" :value="1"></el-option>
                <el-option label="2" :value="2"></el-option>
              </el-select>
            </template>
            <template slot="action" slot-scope="{ row, $index }">
              <span class="space-x-2">
                <c-link @click="onEditCar(row, $index)" label="修改"></c-link>
                <c-link @click="onDelCar($index)" label="删除"></c-link>
              </span>
            </template>
          </c-table>
        </template>
        <c-link @click="onAddCar" class="align-top" label="添加"></c-link>
      </el-form-item>

      <el-form-item label="卸货方式" prop="unload_type">
        <el-radio-group v-model="form.unload_type">
          <el-radio :label="1">平地卸货</el-radio>
          <el-radio :label="2">翻板卸货</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="车辆数量上限" prop="vehicle_count_limit">
        <el-input-number
          class="inputNumber w-96"
          v-model="form.vehicle_count_limit"
          controls-position="right"
          :min="0"
          :controls="false"
          placeholder="0表示关闭叫号"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="装卸点取样员" prop="sampling_user_ids">
        <tableSelector
          title="选择装卸点取样员"
          v-model="form.sampling_user_ids"
          :rows.sync="form.sampling_user_list"
          :columns="userColumns"
          :params="sampling_user_params"
          :http-request="userLoad"
          @close="onSamplingClose"
        >
          <div class="mb-4" slot="search">
            <el-input
              class="w-60"
              clearable
              v-model="sampling_user_params.keyword"
              placeholder="搜索账号、手机号和联系人"
            ></el-input>
            <span style="margin-left: 10px;">角色：</span>
            <el-select
              multiple
              v-model="sampling_user_params.role_id"
              clearable
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in baseRoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div slot="content">
            <span v-if="form.sampling_user_list.length > 0">{{
              form.sampling_user_list | formatUser
            }}</span>
          </div>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择人员</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="装卸点装卸员" prop="manage_user_ids">
        <tableSelector
          title="装卸点装卸员"
          v-model="form.manage_user_ids"
          :rows.sync="form.manage_user_list"
          :columns="userColumns"
          :params="manage_user_params"
          :http-request="userLoad"
          @close="onManageClose"
        >
          <div class="mb-4" slot="search">
            <el-input
              class="w-60"
              v-model="manage_user_params.keyword"
              clearable
              placeholder="搜索账号、手机号和联系人"
            ></el-input>
            <span style="margin-left: 10px;">角色：</span>
            <el-select
              multiple
              v-model="manage_user_params.role_id"
              clearable
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in baseRoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div slot="content">
            <span v-if="form.manage_user_list.length > 0">{{
              form.manage_user_list | formatUser
            }}</span>
          </div>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择人员</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="卸货区间控制" prop="call_interval">
        <el-input-number
          placeholder="请输入叫号区间"
          class="inputNumber w-96"
          :step="1"
          step-strictly
          v-model="form.call_interval"
          controls-position="right"
          :min="1"
          :controls="false"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="卸货指引" prop="landing_guide_id">
        <tableSelector
          :multiple="false"
          title="选择卸货指引"
          v-model="form.landing_guide_id"
          :rows.sync="form.landing_guide"
          url="/api/queue/admin/query_guide"
          :params="landing_guide_params"
          :columns="guideColumns"
        >
          <template slot="content">
            <div>
              <div v-for="item in form.landing_guide" :key="item.id">
                {{ item.name }}
              </div>
            </div>
          </template>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="提货指引" prop="delivery_guide_id">
        <tableSelector
          :multiple="false"
          title="选择提货指引"
          v-model="form.delivery_guide_id"
          :rows.sync="form.delivery_guide"
          url="/api/queue/admin/query_guide"
          :params="delivery_guide_params"
          :columns="guideColumns"
        >
          <template slot="content">
            <div>
              <div v-for="item in form.delivery_guide" :key="item.id">
                {{ item.name }}
              </div>
            </div>
          </template>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder="请输入备注"
          v-model="form.note"
          class="w-96"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div style="height: 56px;"></div>
    <div
      class="absolute bottom-0 left-0 space-x-4 bg-white w-full px-4 py-2 box-border z-50 border-t border-solid border-gray-200"
    >
      <el-button size="small" @click="onSave" type="primary">{{
        this.recordId == 0 ? "新建" : "保存"
      }}</el-button>
    </div>
    <el-dialog
      title="添加车辆业务类型"
      :visible.sync="addCarVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form
        ref="carForm"
        :model="carForm"
        label-width="120px"
        :rules="carFormRules"
      >
        <el-form-item label="车辆业务类型" prop="car_business_id">
          <tableSelector
            :multiple="false"
            title="选择车辆业务类型"
            v-model="carForm.car_business_id"
            :rows.sync="carForm.car_business"
            url="/api/queue/admin/query_business"
            :params="{
              is_parent: 1,
              state: 1,
              keyword: businessKeyword
            }"
            :columns="carBusinessColumns"
          >
            <div class="mb-4" slot="search">
              <span>关键字：</span
              ><el-input
                class="w-60"
                v-model="businessKeyword"
                placeholder="输入关键字搜索"
              ></el-input>
            </div>
            <template slot="content">
              <div>
                <div v-for="item in carForm.car_business" :key="item.id">
                  {{ item.name }}
                </div>
              </div>
            </template>
            <el-link type="primary" :underline="false">选择业务类型</el-link>
          </tableSelector>
        </el-form-item>
        <el-form-item label="仅装卸比例" prop="unload_ratio">
          <el-input-number
            class="inputNumber w-24"
            v-model="carForm.unload_ratio"
            controls-position="right"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number
          ><span class="ml-2">%</span>
        </el-form-item>
        <el-form-item
          label="取样+装卸"
          prop="sampling_unload_ratio"
          v-if="form.loading_unloading_type == 11"
        >
          <el-input-number
            class="inputNumber w-24"
            v-model="carForm.sampling_unload_ratio"
            controls-position="right"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number
          ><span class="ml-2">%</span>
        </el-form-item>
        <el-form-item label="叫号优先级" prop="calling_priority">
          <el-select v-model="carForm.calling_priority" placeholder="请选择优先级" class="w-96">
            <el-option label="不优先" :value="0"></el-option>
            <el-option label="1（最高）" :value="1"></el-option>
            <el-option label="2" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onAddCarCancel">取 消</el-button>
        <el-button type="primary" @click="onAddCarConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableSelector from "@/components/tableSelector/index.vue";
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";
export default {
  data() {
    return {
      addCarVisible: false,
      visible: false,
      form: {
        car_business_list: [],
        sampling_user_list: [],
        manage_user_list: [],
        unload_type: 1,
        loading_unloading_type: 11,
        vehicle_count_limit: 0
      },
      businessKeyword: "",
      sampling_user_params: {
        keyword: "",
        role_id: []
      },
      manage_user_params: {
        keyword: "",
        role_id: []
      },
      landing_guide_params: {
        type: 2
      },
      delivery_guide_params: {
        type: 3
      },
      carForm: {
        car_business_id: [],
        car_business: [],
        unload_ratio: undefined,
        sampling_unload_ratio: undefined,
        calling_priority: 0
      },
      carBusinessColumns: [
        { label: "车辆代码", prop: "code" },
        { label: "车辆预约业务类型", prop: "name" }
      ],
      rules: {
        name: [
          { required: true, message: "请输入装卸点名称", trigger: "blur" }
        ],
        unload_type: [
          { required: true, message: "请选择卸货方式", trigger: "blur" }
        ],
        loading_unloading_type: [
          { required: true, message: "请选择装卸类型", trigger: "change" }
        ],
        car_business_list: [
          {
            required: false,
            message: "请选择车辆业务类型",
            trigger: "change",
            type: "array"
          }
        ],
        sampling_user_ids: [
          {
            required: true,
            message: "请选择装卸点取样员",
            trigger: "change",
            type: "array"
          }
        ],
        manage_user_ids: [
          {
            required: true,
            message: "请选择装卸点管理员",
            trigger: "change",
            type: "array"
          }
        ],
        call_interval: [
          {
            required: true,
            message: "请输入叫号区间",
            trigger: "blur",
            type: "number"
          }
        ]
      },
      carFormRules: {
        car_business_id: [
          {
            required: true,
            message: "请选择车辆业务类型",
            trigger: "change",
            type: "array"
          }
        ],
        sampling_ratio: [
          { required: true, message: "请输入取样比例", trigger: "blur" }
        ]
      },
      columns: [
        {
          label: "车辆业务类型",
          prop: "car_business_name"
        },
        {
          label: "仅装卸比例(%)",
          prop: "unload_ratio",
          width: 120
        },
        {
          label: "取样+装卸(%)",
          prop: "sampling_unload_ratio",
          width: 120,
          show: () => this.form.loading_unloading_type == 11
        },
        {
          label: "叫号优先级",
          prop: "calling_priority",
          width: 140
        },
        {
          label: "操作",
          prop: "action",
          width: 100
        }
      ],
      userColumns: [
        { label: "联系人", prop: "contact" },
        { label: "账号", prop: "account" },
        { label: "角色", prop: "role_name" }
      ],
      guideColumns: [{ label: "指引名称", prop: "name" }]
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "baseRole"]),
    recordId() {
      return this.$route.params.id;
    },
    baseRoleList() {
      return this.baseRole.filter(e => {
        const insider = [
          "admin",
          "sampler",
          "sample_receiver",
          "stevedore",
          "gate_guard"
        ].includes(e.code);
        const isCustom = e.code.indexOf("custom-") === 0;
        return insider || isCustom;
      });
    }
  },
  components: {
    tableSelector
  },
  filters: {
    formatUser(list) {
      return list.map(e => e.contact).join("；");
    }
  },
  created() {
    if (this.recordId != 0) {
      this.getDetail();
    }
  },
  methods: {
    onSave() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const {
              landing_guide_id,
              landing_guide,
              delivery_guide_id,
              delivery_guide,
              car_business_list,
              manage_user_list,
              sampling_user_list,
              ...params
            } = this.form;
            const formData = {
              ...params,
              landing_guide_id: String(landing_guide_id),
              delivery_guide_id: String(delivery_guide_id),
              car_business_list: car_business_list.map(item => {
                const { car_business, ...other } = item;
                return {
                  ...other,
                  car_business_id: String(other.car_business_id),
                  calling_priority: Number(other.calling_priority || 0)
                };
              }),
              id: this.recordId == 0 ? "" : this.recordId
            };
            await this.$common.http({
              url:
                this.recordId == 0
                  ? "/api/queue/admin/create_warehouse"
                  : "/api/queue/admin/update_warehouse",
              data: formData
            });
            this.$common.pcToastSuccess(`保存成功`);
          } catch (error) {
            console.log(error);
          }
          this.$router.back();
        }
      });
    },
    async userLoad(params) {
      const defaultRoleId = this.baseRoleList.map((e) => e.id).join(',');
      const dataObj = await this.$common.http({
        url: "/api/contact/search",
        data: {
          ...params,
          role_id: (params.role_id && params.role_id.length > 0) ? params.role_id.join(",") : defaultRoleId,
          is_select: 1,
          limit: params.page_size,
          offset: (params.page - 1) * params.page_size,
          type: 2
        }
      });
      return {
        data: dataObj.data.data.items,
        total: dataObj.data.data.total
      };
    },
    onAddCar() {
      this.addCarVisible = true;
    },
    onAddCarCancel() {
      this.addCarVisible = false;
      this.carForm = {
        car_business_id: [],
        car_business: [],
        unload_ratio: undefined,
        sampling_unload_ratio: undefined,
        calling_priority: 0
      };
    },
    onAddCarConfirm() {
      this.$refs.carForm.validate(valid => {
        if (valid) {
          if (this.carForm.index != undefined) {
            this.$set(this.form.car_business_list, this.carForm.index, {
              ...this.carForm
            });
          } else {
            this.form.car_business_list.push({ ...this.carForm });
          }
          this.onAddCarCancel();
        }
      });
    },
    onEditCar(row, index) {
      this.carForm = {
        index,
        car_business_id: [row.car_business_id],
        car_business: row.car_business,
        unload_ratio: row.unload_ratio,
        sampling_unload_ratio: row.sampling_unload_ratio,
        calling_priority: row.calling_priority || 0
      };
      this.addCarVisible = true;
    },
    onDelCar(index) {
      this.form.car_business_list.splice(index, 1);
    },
    onLoadingUnloadingTypeChange() {
      this.form.car_business_list = [];
    },
    onManageClose() {
      this.manage_user_params.keyword = '';
      this.manage_user_params.role_id = [];
    },
    onSamplingClose() {
      this.sampling_user_params.keyword = '';
      this.sampling_user_params.role_id = [];
    },
    // 获取详情
    async getDetail() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/detail_warehouse",
          data: {
            id: this.recordId
          }
        });
        const {
          name,
          loading_unloading_type,
          unload_type,
          sampling_user_ids,
          sampling_user_list,
          manage_user_ids,
          manage_user_list,
          landing_guide_id,
          landing_guide_name,
          delivery_guide_id,
          delivery_guide_name,
          call_interval,
          vehicle_count_limit,
          car_business_list,
          note
        } = dataObj.data.data;
        let formData = {};
        formData.loading_unloading_type = loading_unloading_type;
        formData.name = name;
        formData.unload_type = unload_type;
        formData.car_business_list = car_business_list.map(item => {
          return {
            ...item,
            calling_priority: item.calling_priority || 0,
            car_business: [
              { id: item.car_business_id, name: item.car_business_name }
            ]
          };
        });
        formData.sampling_user_ids = JSON.parse(sampling_user_ids);
        formData.manage_user_ids = JSON.parse(manage_user_ids);
        formData.sampling_user_list = sampling_user_list.map(item => {
          return {
            ...item,
            contact: item.name
          };
        });
        formData.manage_user_list = manage_user_list.map(item => {
          return {
            ...item,
            contact: item.name
          };
        });
        formData.landing_guide_id = [landing_guide_id];
        formData.landing_guide = [
          { id: landing_guide_id, name: landing_guide_name }
        ];
        formData.delivery_guide_id = [delivery_guide_id];
        formData.delivery_guide = [
          { id: delivery_guide_id, name: delivery_guide_name }
        ];
        formData.call_interval = call_interval;
        formData.vehicle_count_limit = vehicle_count_limit || 0;
        formData.note = note;
        this.form = cloneDeep(formData);
      } catch (error) {}
    }
  }
};
</script>

<style lang="less" scoped>
.inputNumber {
  /deep/ .el-input__inner {
    text-align: left !important;
  }
}
/deep/ .el-input__validateIcon {
  display: none;
}
</style>
